import { render, staticRenderFns } from "./ComingSoonDialog.vue?vue&type=template&id=e7fc54ae&"
import script from "./ComingSoonDialog.vue?vue&type=script&lang=js&"
export * from "./ComingSoonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports